<div class="scootaverse-card" [attr.data-testid]="'enter-' + roomSet?.name + '-button'">
  <div class="title-card-container">
    <div class="title-card-row">
      <input
        [(ngModel)]="newScootaverseName"
        [readonly]="!editingName"
        type="text"
        [ngClass]="{
          'edit-name-input': editingName,
          'name-text': !editingName,
        }"
        maxLength="256"
        (dblclick)="startEditing(roomSet?.name)"
        (blur)="editScootaverseName()"
      />
      @if (!attachPage) {
        <div class="more-options">
          <button type="button" class="kebab-btn m-l-10" [matMenuTriggerFor]="menu" [attr.data-testid]="roomSet?.name">
            <mat-icon class="kebab-menu-icon">more_vert</mat-icon>
          </button>
          <mat-menu role="menu" #menu="matMenu" xPosition="before" class="saved-rooms-options-menu">
            @if (roomSet && roomSet.socials && roomSet.socials.length > 0) {
              <button
                type="button"
                mat-menu-item
                role="menuitem"
                (click)="onScootaverseShareLink(roomSet)"
                data-testid="share-button"
                class="scootaverse-card-share-button"
              >
                Share Link
              </button>
            }

            <button
              type="button"
              mat-menu-item
              role="menuitem"
              (click)="onEnterScootaverse()"
              data-testid="edit-button"
            >
              Edit
            </button>
            <button
              type="button"
              mat-menu-item
              role="menuitem"
              (click)="onDeleteScootaverse()"
              data-testid="delete-button"
            >
              Delete
            </button>
            <button
              type="button"
              mat-menu-item
              role="menuitem"
              data-testid="duplicate-scootaverse-button"
              (click)="duplicateScootaverse()"
            >
              Duplicate
            </button>
          </mat-menu>
        </div>
      }
    </div>
    @if (roomSet?.description) {
      <div class="subtitle-card-row" (click)="onCardClick()">
        <div class="subtitle-text">
          {{ roomSet?.description }}
        </div>
      </div>
    }
  </div>

  <div class="card-body" (click)="onCardClick()" [ngClass]="{ 'hover-disabled': disableHover }">
    <room-background-card [theme]="socialTheme" [isScootaverseCard]="true"></room-background-card>
  </div>
  <div class="footer-card-row">
    @if (attachPage) {
      <button class="footer-edit-button" type="button" (click)="onEditScootaverse(roomSet)" data-testid="edit-button">
        Edit
      </button>
    }
  </div>
</div>
